module.exports = __webpack_public_path__ + "static/img/sjfk.4721037f.png";